import grid from './grid'

const events =
{
    ...grid,
    helmet :
    {
        title : 'Événements' ,
        metas : []
    },
    empty  : 'Aucun événement trouvé',
    search : 'Rechercher un événement ...' ,
    title  : 'Événements'
};

export default events ;
